<app-base [loading]="loading"></app-base>